export default function (scaling) {
  this.scaling = scaling
  this._scaling = scaling
}
